/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

export class Priority {
	public color?: string;
	public sortOrder?: number;
	public text?: string;
	public $id: string;

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	public constructor(obj: any, id: string) {
		this.$id = id;
		this.update(obj, id);
	}

	public update(
		obj: { color: string | undefined; sortOrder: number | undefined; text: string | undefined },
		id?: string
	): void {
		this.color = obj.color;
		this.sortOrder = obj.sortOrder;
		this.text = obj.text;
	}
}
